import {DateTimePicker, LocalizationProvider} from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {Button, CardHeader, Dialog, DialogActions, DialogContent, DialogTitle, Grid, MenuItem, Paper, Select, Skeleton, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography} from "@mui/material";
import {withStyles} from "@mui/styles";
import axios from "axios";
import * as React from "react";
import {Config} from "../../config/config";
import {Helpers} from "../../utils/helpers";
import {PopupMessage} from "../../utils/message";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import {green, red} from '@mui/material/colors';
import NotInterestedIcon from "@mui/icons-material/NotInterested";

const rewardTypes = [
    {key: "Honey", value: "Gold"},
    {key: "Flowers", value: "Oil"},
    {key: "Sapphire", value: "Rubies"},
    {key: "Ruby", value: "MarketRuby"},
]

class RubyCompetitionWrapped extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: false,
            filter: {
                startDate: new Date(),
                endDate: new Date(),
                type: "",
                status: "",
                isRewarded: -1,
                offset: 0,
                limit: 20,
                selectAllTime: true
            },
            content: [],
            types: [],
            statuses: [],
            detailDialog: {
                open: false,
                data: null,
                newReward: {
                    from: 1,
                    to: 1,
                    gold: 0,
                    oil: 0,
                    sapphire: 0,
                    ruby: 0,
                },
                configDialog: false
            },
            createDialog: {
                open: false,
                data: {
                    name: "",
                    type: "highest_win_rate",
                    status: "activated",
                    winnerAmount: 10,
                    startDate: new Date(),
                    endDate: new Date(),
                },
            },
            statsDialog: {
                open: false,
                data: [],
                page: 0,
                rowsPerPage: 50
            }
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    renderStatus(status: string) {
        let color = "green";

        if (status === "deactivated") {
            color = "grey";
        }

        if (status === "expired") {
            color = "orange";
        }

        return <Typography> <span style={{color}}>{status}</span></Typography>;

    }

    validateDate(startTime: Date, endTime: Date): boolean {
        const s = new Date(startTime);
        const e = new Date(endTime);
        return +e > +s;
    }

    async fetchData() {
        const url = `${Config.getInstance.apiUrl}/api/ruby_competition/`;

        this.setState({
            loading: true,
        });

        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const filter = this.state.filter;

        const response = await axios.get(url, {
            params: filter,
            headers
        });

        const data = response.data;
        const success = data.success;

        this.setState({
            loading: false,
        });

        if (success) {
            const competitions = data.competitions;
            const types = [...[{value: "ALL", key: "ALL"}], ...data.types];
            const statuses = [...[{value: "ALL", key: "ALL"}], ...data.statuses];

            if (filter.type === "") filter.type = types[0].key;
            if (filter.status === "") filter.status = statuses[0].key;

            this.setState({
                content: competitions,
                types,
                statuses
            });
        } else {
            PopupMessage.error("Failed to fetch data")
        }
    }

    async updateCompetition() {
        const url = `${Config.getInstance.apiUrl}/api/ruby_competition/`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const competition = this.state.detailDialog.data;

        const body = competition;

        if (!this.validateDate(body.startDate, body.endDate)) {
            PopupMessage.error("End time must be greater than start time");
            return;
        }

        this.setState({
            loading: true,
        })

        const response = await axios.put(url, body, {
            headers
        });

        this.setState({
            loading: false,
        })
        const success = response.data.success;

        if (!success) {
            const msg = response.data.message || "Failed to update competition";
            PopupMessage.error(msg);
            this.onOpenDetailDialog(competition);
            return;
        }

        this.onClosedDetailDialog();
        this.fetchData();
    }

    async onRewarding() {
        const competition = this.state.detailDialog.data;

        if (!competition) {
            PopupMessage.error("Invalid competition");
            return;
        }

        // Confirm dialog
        if (!window.confirm("Are you sure to reward this competition?")) {
            return;
        }

        const now = +new Date();
        const endDate = +new Date(competition.endDate);

        if (endDate > now) {
            if (!window.confirm("This competition is not ended yet. Are you sure to reward?")) {
                return;
            }
        }

        const url = `${Config.getInstance.apiUrl}/api/ruby_competition/rewarding`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const body = {
            id: competition.id
        }

        axios.post(url, body, {
            headers
        }).then((response) => {
            const success = response.data.success;

            if (!success) {
                PopupMessage.error("Failed to reward");
            }

            this.fetchData();
        }).catch((e) => {
            PopupMessage.error("Failed to reward");
        });
    }

    async fetchStats() {
        const url = `${Config.getInstance.apiUrl}/api/ruby_competition/stats`;

        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const competition = this.state.detailDialog.data;

        const params = {
            id: competition.id
        }

        this.setState({
            loading: true,
        });

        const response = await axios.get(url, {
            params,
            headers
        });

        this.setState({
            loading: false,
        });

        const success = response.data.success;

        if (!success) {
            PopupMessage.error("Failed to fetch stats");
        }

        this.setState({
            statsDialog: {
                open: true,
                data: response.data.stats,
                page: 0,
                rowsPerPage: 50
            }
        });

        this.onOpenStatsDialog();
    }

    async onCreateCompetition() {
        const url = `${Config.getInstance.apiUrl}/api/ruby_competition/`;

        const body = this.state.createDialog.data;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        if (!this.validateDate(body.startDate, body.endDate)) {
            PopupMessage.error("End time must be greater than start time");
            return;
        }

        const response = await axios.post(url, body, {
            headers
        });

        const success = response.data.success;

        if (!success) {
            const msg = response.data.message || "Failed to create competition";
            PopupMessage.error(msg);
            this.onAddItem();
            return;
        }

        this.onClosedCreateDialog();
        this.fetchData();
    }

    handleChangeTime = (key: string, value: any) => {
        const filter = this.state.filter;
        filter[key] = value;
        this.setState({
            filter
        });
    }

    handleChangeFilter = (event: any, key: string) => {
        const filter = this.state.filter;
        filter[key] = event.target.value;
        this.setState({
            filter
        });
    }

    formatTime = (time: string) => {
        return new Date(time).toLocaleString();
    }

    onAddItem = () => {
        const createDialog = this.state.createDialog;
        createDialog.open = true;
        this.setState({
            createDialog
        });
    }

    onEditItem = (competition: any) => {
        this.onOpenDetailDialog(competition);
    }

    onOpenDetailDialog = (competition: any) => {
        this.setState({
            detailDialog: {
                open: true,
                data: competition,
                newReward: {
                    from: 1,
                    to: 1,
                    gold: 0,
                    oil: 0,
                    sapphire: 0,
                    ruby: 0,
                },
            }
        });
    }

    onClosedDetailDialog = () => {
        this.setState({
            detailDialog: {
                open: false,
                data: null,
                newReward: {
                    from: 1,
                    to: 1,
                    gold: 0,
                    oil: 0,
                    sapphire: 0,
                    ruby: 0,
                },
            }
        });


        this.fetchData();
    }

    onDetailChange(event: any, key: string) {
        const detailDialog = this.state.detailDialog;
        const competition = detailDialog.data;

        if (!competition) {
            return;
        }

        competition[key] = event.target.value;

        this.setState({
            detailDialog
        });
    }

    handleChangeCreateTime(key: string, value: any) {
        const createDialog = this.state.createDialog;
        createDialog.data[key] = value;
        this.setState({
            createDialog
        });
    }

    handleChangeDetailTime(key: string, value: any) {
        const detailDialog = this.state.detailDialog;
        const competition = detailDialog.data;

        if (!competition) {
            return;
        }

        competition[key] = value;

        this.setState({
            detailDialog
        });
    }

    onChangeConfig(event: any, key: string) {
        const detailDialog = this.state.detailDialog;
        const competition = detailDialog.data;


        if (!competition) {
            return;
        }

        const config = competition.config || {};

        config[key] = event.target.value;

        competition.config = config;

        this.setState({
            detailDialog
        });
    }

    onChangeNewReward(event: any, key: string) {
        const detailDialog = this.state.detailDialog;
        const newReward = detailDialog.newReward;

        newReward[key] = event.target.value;

        this.setState({
            detailDialog
        });
    }

    onAddNewReward() {
        const detailDialog = this.state.detailDialog;

        const competition = detailDialog.data;

        if (!competition) {
            return;
        }

        const config = competition.config || {};

        const rewardConfig = config.rewardConfig || [];

        rewardConfig.push({...detailDialog.newReward});

        config.rewardConfig = rewardConfig;

        competition.config = config;

        this.setState({
            detailDialog
        });
    }

    onRemoveReward(index: number) {
        const detailDialog = this.state.detailDialog;

        const competition = detailDialog.data;

        if (!competition) {
            return;
        }

        const config = competition.config || {};

        const rewardConfig = config.rewardConfig || [];

        rewardConfig.splice(index, 1);

        config.rewardConfig = rewardConfig;

        competition.config = config;

        this.setState({
            detailDialog
        });
    }

    onChangeRewardConfig = (event: any, key: string, index: number) => {
        const detailDialog = this.state.detailDialog;
        const competition = detailDialog.data;

        if (!competition) {
            return;
        }

        const config = competition.config || {};

        const rewardConfig = config.rewardConfig || [];

        rewardConfig[index][key] = event.target.value;

        config.rewardConfig = rewardConfig;

        competition.config = config;

        this.setState({
            detailDialog
        });
    }

    onClosedCreateDialog() {
        const createDialog = this.state.createDialog;
        createDialog.open = false;
        createDialog.data = {
            name: "",
            type: "highest_win_rate",
            status: "activated",
            winnerAmount: 10,
            startDate: new Date(),
            endDate: new Date(),
        };
        this.setState({
            createDialog
        });
    }

    onChangeCreateDialog(event: any, key: string) {
        const createDialog = this.state.createDialog;
        createDialog.data[key] = event.target.value;
        this.setState({
            createDialog
        });
    }

    onChangeStatsDialog(event: any, key: string, value: any = null) {
        const statsDialog = this.state.statsDialog;
        statsDialog[key] = value === null ? event.target.value : value;

        console.log("statsDialog", statsDialog);
        console.log("value", event.target.value);
        this.setState({
            statsDialog
        });
    }

    onOpenConfigDialog() {
        const detailDialog = this.state.detailDialog;
        detailDialog.configDialog = true;
        this.setState({
            detailDialog
        });
    }

    onClosedConfigDialog() {
        const detailDialog = this.state.detailDialog;
        detailDialog.configDialog = false;
        this.setState({
            detailDialog
        });
    }

    onOpenStatsDialog() {
        const statsDialog = this.state.statsDialog;
        statsDialog.open = true;
        this.setState({
            statsDialog
        });
    }

    onClosedStatsDialog() {
        const statsDialog = this.state.statsDialog;
        statsDialog.open = false;
        this.setState({
            statsDialog
        });
    }

    renderStatsDialog() {
        const statsDialog = this.state.statsDialog;
        const data = statsDialog.data;

        const {page, rowsPerPage} = statsDialog;

        const visibleRows = data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

        return <Dialog
            open={statsDialog.open}
            onClose={() => {
                this.onClosedStatsDialog();
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth="lg"
        >

            <DialogTitle id="alert-dialog-title">{"Stats"}</DialogTitle>
            <DialogContent dividers>
                {data.length === 0 ? <div className="no-items-placeholder">
                    <NotInterestedIcon />
                    <h3>No players found</h3>
                </div>
                    :
                    <TableContainer>
                        <Table className="min-table-size">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Rank</TableCell>
                                    <TableCell>UserID</TableCell>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Squad</TableCell>
                                    <TableCell>TotalMatch</TableCell>
                                    <TableCell>WinRate</TableCell>
                                    <TableCell>TotalWin</TableCell>
                                    <TableCell>TotalLose</TableCell>
                                    <TableCell>TotalEarn</TableCell>
                                    <TableCell>TotalWager</TableCell>
                                    <TableCell>AVG Destroy</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    visibleRows.map((item: any, index: number) => {
                                        return <TableRow key={index}>
                                            <TableCell>{item.rank}</TableCell>
                                            <TableCell>{item.userId}</TableCell>
                                            <TableCell>{item.meta.name}</TableCell>
                                            <TableCell>{item.meta.squad_name || 'No Squad'}</TableCell>
                                            <TableCell>{item.totalMatch}</TableCell>
                                            <TableCell>{`${(item.winRate).toFixed(2)}%`}</TableCell>
                                            <TableCell>{item.totalWin}</TableCell>
                                            <TableCell>{item.totalLose}</TableCell>
                                            <TableCell>{item.totalEarn}</TableCell>
                                            <TableCell>{item.totalWager}</TableCell>
                                            <TableCell>{`${(item.averageDestruction).toFixed(2)}%`}</TableCell>
                                        </TableRow>
                                    })
                                }
                            </TableBody>
                        </Table>
                        <TablePagination
                            component={"div"}
                            count={data.length}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            onPageChange={(e, newPage) => this.onChangeStatsDialog(e, "page", newPage)}
                            onRowsPerPageChange={(e) => this.onChangeStatsDialog(e, "rowsPerPage")}
                        />
                    </TableContainer>
                }
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => this.onClosedStatsDialog()}
                    color="primary"
                    variant="contained"
                    disableElevation
                >
                    Done
                </Button>
            </DialogActions>
        </Dialog>
    }

    renderCreateDialog() {
        const createDialog = this.state.createDialog;
        const data = createDialog.data;

        const textStyle = {
            display: "flex",
            alignItems: "center",
        }

        return <Dialog
            open={createDialog.open}
            onClose={() => {
                this.onClosedCreateDialog();
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth="lg"
        >
            <DialogContent dividers>
                <Grid item container spacing={2} sm={12}>
                    <Grid item sm={12}>
                        <Typography variant="h4" style={{textAlign: "center"}}>
                            Create Competition
                        </Typography>
                    </Grid>

                    <Grid container item sm={12}>
                        <Grid item sm={3} style={textStyle}>
                            <Typography variant="h6">
                                Name:
                            </Typography>
                        </Grid>
                        <Grid item sm={7}>
                            <TextField
                                value={data.name}
                                defaultValue={data.name}
                                onChange={(e) => this.onChangeCreateDialog(e, "name")}
                                fullWidth
                            >
                            </TextField>
                        </Grid>
                    </Grid>

                    <Grid container item sm={12}>
                        <Grid item sm={3} style={textStyle}>
                            <Typography variant="h6">
                                Type:
                            </Typography>
                        </Grid>
                        <Grid item sm={7}>
                            <TextField
                                value={data.type}
                                select
                                defaultValue={data.type}
                                onChange={(e) => this.onChangeCreateDialog(e, "type")}
                                fullWidth
                            >
                                {this.state.types.map((type: any) => (
                                    type.value === "ALL" ? null :
                                        <MenuItem key={type.value} value={type.value}>
                                            {type.value}
                                        </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                    </Grid>

                    <Grid container item sm={12}>
                        <Grid item sm={3} style={textStyle}>
                            <Typography variant="h6">
                                Status:
                            </Typography>
                        </Grid>
                        <Grid item sm={7}>
                            <TextField
                                value={data.status}
                                select
                                defaultValue={data.status}
                                onChange={(e) => this.onChangeCreateDialog(e, "status")}
                                fullWidth
                            >
                                {this.state.statuses.map((type: any) => (
                                    type.value === "ALL" ? null :
                                        <MenuItem key={type.value} value={type.value}>
                                            {type.value}
                                        </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                    </Grid>

                    <Grid container item sm={12}>
                        <Grid item sm={3} style={textStyle}>
                            <Typography variant="h6">
                                Winner Amount:
                            </Typography>
                        </Grid>
                        <Grid item sm={7}>
                            <TextField
                                value={data.winnerAmount}
                                onChange={(e) => this.onChangeCreateDialog(e, "winnerAmount")}
                                fullWidth
                            >
                            </TextField>
                        </Grid>
                    </Grid>

                    <Grid container item sm={12}>
                        <Grid item sm={3} style={textStyle}>
                            <Typography variant="h6">
                                Start time:
                            </Typography>
                        </Grid>
                        <Grid item sm={7}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}
                            >
                                <DateTimePicker
                                    label="Start Time"
                                    value={data.startDate}
                                    onChange={(e) => this.handleChangeCreateTime("startDate", e)}
                                    renderInput={(params) => <TextField {...params} size="small" />}
                                    ampm={false}
                                />
                            </LocalizationProvider>
                        </Grid>
                    </Grid>

                    <Grid container item sm={12}>
                        <Grid item sm={3} style={textStyle}>
                            <Typography variant="h6">
                                End time:
                            </Typography>
                        </Grid>
                        <Grid item sm={7}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}
                            >
                                <DateTimePicker
                                    label="End Time"
                                    value={data.endDate}
                                    onChange={(e) => this.handleChangeCreateTime("endDate", e)}
                                    renderInput={(params) => <TextField {...params} size="small" />}
                                    ampm={false}
                                />
                            </LocalizationProvider>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => this.onClosedCreateDialog()}
                    color="secondary"
                    variant="contained"
                    disableElevation
                >
                    Cancel
                </Button>
                <Button
                    onClick={() => this.onCreateCompetition()}
                    color="primary"
                    variant="contained"
                    disableElevation
                >Create</Button>
            </DialogActions>
        </Dialog>
    }

    renderConfig() {
        // const competitionId = this.state.detailDialog.data?.id || "";
        // const competition = this.state.content.find((item: any) => item.id === competitionId) || null;

        const competition = this.state.detailDialog.data;
        if (!competition) {
            return null;
        }

        const textStyle = {
            display: "flex",
            alignItems: "center",
        }

        const config = competition.config || {};
        const rewardConfig = config.rewardConfig || [];
        const newReward = this.state.detailDialog.newReward;

        return <Dialog
            open={this.state.detailDialog.configDialog}
            onClose={() => {
                this.onClosedConfigDialog();
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth="lg"
        >
            <DialogTitle id="alert-dialog-title">{"Config"}</DialogTitle>
            <DialogContent dividers>
                <Grid item container spacing={2} sm={12}>
                    <Grid item sm={12}>
                        <TextField
                            label="MinMatchAmount"
                            value={config.minMatchAmount || 0}
                            onChange={(e) => this.onChangeConfig(e, "minMatchAmount")}
                            type="number"
                        >
                        </TextField>
                    </Grid>
                </Grid>
                <Typography variant="h6" component="div" style={{padding: '16px'}}>
                    Reward Configs
                </Typography>
                <Table
                    title="Reward Config"
                >
                    <TableHead>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Rank From</TableCell>
                            <TableCell>To</TableCell>
                            <TableCell>Gold</TableCell>
                            <TableCell>Oil</TableCell>
                            <TableCell>Sapphire</TableCell>
                            <TableCell>Ruby</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>Add</TableCell>
                            <TableCell>
                                <TextField
                                    value={newReward.from}
                                    onChange={(e) => this.onChangeNewReward(e, "from")}
                                    type="number"
                                >
                                </TextField>
                            </TableCell>
                            <TableCell>
                                <TextField
                                    value={newReward.to}
                                    onChange={(e) => this.onChangeNewReward(e, "to")}
                                    type="number"
                                >
                                </TextField>
                            </TableCell>
                            <TableCell>
                                <TextField
                                    value={newReward.gold}
                                    onChange={(e) => this.onChangeNewReward(e, "gold")}
                                    type="number"
                                >
                                </TextField>
                            </TableCell>
                            <TableCell>
                                <TextField
                                    value={newReward.oil}
                                    onChange={(e) => this.onChangeNewReward(e, "oil")}
                                    type="number"
                                >
                                </TextField>
                            </TableCell>
                            <TableCell>
                                <TextField
                                    value={newReward.sapphire}
                                    onChange={(e) => this.onChangeNewReward(e, "sapphire")}
                                    type="number"
                                >
                                </TextField>
                            </TableCell>
                            <TableCell>
                                <TextField
                                    value={newReward.ruby}
                                    onChange={(e) => this.onChangeNewReward(e, "ruby")}
                                    type="number"
                                >
                                </TextField>
                            </TableCell>
                            <TableCell>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.onAddNewReward.bind(this)}
                                >
                                    Add
                                </Button>
                            </TableCell>
                        </TableRow>
                        {
                            rewardConfig.map((config: any, index: number) => {
                                const {from, to, gold, oil, sapphire, ruby} = config;
                                return <TableRow key={index}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>
                                        <TextField
                                            value={from}
                                            onChange={(e) => this.onChangeRewardConfig(e, "from", index)}
                                            type="number"
                                        >
                                        </TextField>
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            value={to}
                                            onChange={(e) => this.onChangeRewardConfig(e, "to", index)}
                                            type="number"
                                        >
                                        </TextField>
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            value={gold}
                                            onChange={(e) => this.onChangeRewardConfig(e, "gold", index)}
                                            type="number"
                                        >
                                        </TextField>
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            value={oil}
                                            onChange={(e) => this.onChangeRewardConfig(e, "oil", index)}
                                            type="number"
                                        >
                                        </TextField>
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            value={sapphire}
                                            onChange={(e) => this.onChangeRewardConfig(e, "sapphire", index)}
                                            type="number"
                                        >
                                        </TextField>
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            value={ruby}
                                            onChange={(e) => this.onChangeRewardConfig(e, "ruby", index)}
                                            type="number"
                                        >
                                        </TextField>
                                    </TableCell>
                                    <TableCell>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => this.onRemoveReward(index)}
                                        >
                                            Remove
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            })
                        }
                    </TableBody>
                </Table>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => this.onClosedConfigDialog()}
                    color="primary"
                    variant="contained"
                    disableElevation
                >
                    Done
                </Button>
            </DialogActions>
        </Dialog>
    }

    renderDetailDialog() {
        const competitionId = this.state.detailDialog.data?.id || "";
        const competition = this.state.content.find((item: any) => item.id === competitionId) || null;

        if (!competition) {
            return null;
        }

        const textStyle = {
            display: "flex",
            alignItems: "center",
        }

        const config = competition.config || {};
        const disabled = competition.isRewarded;

        return <Dialog
            open={this.state.detailDialog.open}
            onClose={() => {
                this.onClosedDetailDialog();
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth="lg"
        >
            <DialogContent dividers>
                <Grid container spacing={2} sm={12}>
                    <Grid item container spacing={2} sm={12}>
                        <Grid item sm={12}>
                            <Typography variant="h4" style={{textAlign: "center"}}>
                                Competition Detail
                            </Typography>
                        </Grid>

                        <Grid container item sm={12}>
                            <Grid item sm={3} style={textStyle}>
                                <Typography variant="h6">
                                    Name:
                                </Typography>
                            </Grid>
                            <Grid item sm={7}>
                                <TextField
                                    disabled={disabled}
                                    value={competition.name}
                                    defaultValue={competition.name}
                                    onChange={(e) => this.onDetailChange(e, "type")}
                                    fullWidth
                                >
                                </TextField>
                            </Grid>
                        </Grid>

                        <Grid container item sm={12}>
                            <Grid item sm={3} style={textStyle}>
                                <Typography variant="h6">
                                    Type:
                                </Typography>
                            </Grid>
                            <Grid item sm={7}>
                                <TextField
                                    disabled={disabled}
                                    value={competition.type}
                                    select
                                    defaultValue={competition.type}
                                    onChange={(e) => this.onDetailChange(e, "type")}
                                    fullWidth
                                >
                                    {this.state.types.map((type: any) => (
                                        type.value === "ALL" ? null :
                                            <MenuItem key={type.value} value={type.value}>
                                                {type.value}
                                            </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                        </Grid>

                        <Grid container item sm={12}>
                            <Grid item sm={3} style={textStyle}>
                                <Typography variant="h6">
                                    Status:
                                </Typography>
                            </Grid>
                            <Grid item sm={7}>
                                <TextField
                                    disabled={disabled}
                                    value={competition.status}
                                    select
                                    defaultValue={competition.status}
                                    onChange={(e) => this.onDetailChange(e, "status")}
                                    fullWidth
                                >
                                    {this.state.statuses.map((type: any) => (
                                        type.value === "ALL" ? null :
                                            <MenuItem key={type.value} value={type.value}>
                                                {type.value}
                                            </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                        </Grid>

                        <Grid container item sm={12}>
                            <Grid item sm={3} style={textStyle}>
                                <Typography variant="h6">
                                    Winner Amount:
                                </Typography>
                            </Grid>
                            <Grid item sm={7}>
                                <TextField
                                    disabled={disabled}
                                    value={competition.winnerAmount}
                                    onChange={(e) => this.onDetailChange(e, "winnerAmount")}
                                    fullWidth
                                >
                                </TextField>
                            </Grid>
                        </Grid>

                        <Grid container item sm={12}>
                            <Grid item sm={3} style={textStyle}>
                                <Typography variant="h6">
                                    URL
                                </Typography>
                            </Grid>
                            <Grid item sm={7}>
                                <TextField
                                    value={competition.url}
                                    disabled
                                    fullWidth
                                >
                                </TextField>
                            </Grid>
                        </Grid>

                        <Grid container item sm={12}>
                            <Grid item sm={3} style={textStyle}>
                                <Typography variant="h6">
                                    Creator
                                </Typography>
                            </Grid>
                            <Grid item sm={7}>
                                <TextField
                                    value={competition.creator}
                                    disabled
                                    fullWidth
                                >
                                </TextField>
                            </Grid>
                        </Grid>

                        <Grid container item sm={12}>
                            <Grid item sm={3} style={textStyle}>
                                <Typography variant="h6">
                                    Editor:
                                </Typography>
                            </Grid>
                            <Grid item sm={7}>
                                <TextField
                                    multiline
                                    rows={6}
                                    value={competition.editedBy}
                                    disabled
                                    fullWidth
                                >
                                </TextField>
                            </Grid>
                        </Grid>

                        <Grid container item sm={12}>
                            <Grid item sm={3} style={textStyle}>
                                <Typography variant="h6">
                                    Start time:
                                </Typography>
                            </Grid>
                            <Grid item sm={7}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}
                                >
                                    <DateTimePicker
                                        disabled={disabled}
                                        label="Start Time"
                                        value={competition.startDate}
                                        onChange={(e) => this.handleChangeDetailTime("startDate", e)}
                                        renderInput={(params) => <TextField {...params} size="small" />}
                                        ampm={false}
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>

                        <Grid container item sm={12}>
                            <Grid item sm={3} style={textStyle}>
                                <Typography variant="h6">
                                    End time:
                                </Typography>
                            </Grid>
                            <Grid item sm={7}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}
                                >
                                    <DateTimePicker
                                        disabled={disabled}
                                        label="End Time"
                                        value={competition.endDate}
                                        onChange={(e) => this.handleChangeDetailTime("endDate", e)}
                                        renderInput={(params) => <TextField {...params} size="small" />}
                                        ampm={false}
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>

                        <Grid container item sm={12}>
                            <Grid item sm={3} style={textStyle}>
                                <Typography variant="h6">
                                    Rewarded:
                                </Typography>
                            </Grid>
                            <Grid item sm={7}>
                                {competition.isRewarded ?
                                    <CheckCircleIcon style={{color: green[500]}} /> :
                                    <CancelIcon style={{color: red[500]}} />
                                }
                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>

            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => this.fetchStats()}
                    color="primary"
                    variant="contained"
                    disableElevation
                >
                    Stats
                </Button>
                <Button
                    onClick={() => this.onOpenConfigDialog()}
                    color="primary"
                    variant="contained"
                    disableElevation
                    // left
                    flex-start
                >
                    Config
                </Button>
                <Button
                    onClick={() => this.onClosedDetailDialog()}
                    color="secondary"
                    variant="contained"
                    disableElevation
                >
                    Cancel
                </Button>
                <Button
                    onClick={() => this.onRewarding()}
                    color="primary"
                    variant="contained"
                    disableElevation
                    disabled={competition.isRewarded}
                >
                    Rewarding
                </Button>
                <Button
                    disabled={disabled}
                    onClick={() => this.updateCompetition()}
                    color="primary"
                    variant="contained"
                    disableElevation
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    }

    renderFilter() {
        const filter = this.state.filter;

        return <Paper>
            <Grid container sm={12} rowSpacing={2}>
                <Grid item container sm={12} spacing={2}>
                    <Grid item container sm={2}>
                        <TextField
                            select
                            label="Select Time"
                            value={filter.selectAllTime}
                            onChange={(e) => this.handleChangeFilter(e, "selectAllTime")}
                            defaultValue={filter.selectAllTime}
                            style={{width: "100%"}}
                        >
                            <MenuItem key={true} value={true}>
                                All Time
                            </MenuItem>

                            <MenuItem key={false} value={false}>
                                Custom Time
                            </MenuItem>
                        </TextField>
                    </Grid>
                </Grid>
                <Grid item container sm={12} spacing={2}>
                    <Grid item container sm={3}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DateTimePicker
                                disabled={filter.selectAllTime}
                                label="Start Time"
                                value={filter.startDate}
                                onChange={(e) => this.handleChangeTime("startDate", e)}
                                renderInput={(params) => <TextField {...params} size="small" />}
                                ampm={false}
                                style={{width: "100%"}}
                            />
                        </LocalizationProvider>
                    </Grid>

                    <Grid item container sm={2}>
                        <TextField
                            select
                            label="Type"
                            value={filter.type}
                            onChange={(e) => this.handleChangeFilter(e, "type")}
                            defaultValue={filter.type}
                            style={{width: "100%"}}
                        >
                            {this.state.types.map((type: any) => (
                                <MenuItem key={type.value} value={type.value}>
                                    {type.value}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid item container sm={2}>
                        <TextField
                            select
                            label="Status"
                            value={filter.status}
                            onChange={(e) => this.handleChangeFilter(e, "status")}
                            defaultValue={filter.status}
                            style={{width: "100%"}}
                        >
                            {this.state.statuses.map((type: any) => (
                                <MenuItem key={type.value} value={type.value}>
                                    {type.value}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid item container sm={2}>
                        <TextField
                            select
                            label="Rewarded"
                            value={filter.isRewarded}
                            onChange={(e) => this.handleChangeFilter(e, "isRewarded")}
                            defaultValue={filter.isRewarded}
                            style={{width: "100%"}}
                        >
                            <MenuItem key={-1} value={-1}>
                                ALL
                            </MenuItem>
                            <MenuItem key={true} value={true}>
                                Yes
                            </MenuItem>

                            <MenuItem key={false} value={false}>
                                No
                            </MenuItem>
                        </TextField>
                    </Grid>

                </Grid>

                <Grid item container sm={12} spacing={2}>
                    <Grid item sm={4}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}
                        >
                            <DateTimePicker
                                disabled={filter.selectAllTime}
                                label="End Time"
                                value={filter.endDate}
                                onChange={(e) => this.handleChangeTime("endDate", e)}
                                renderInput={(params) => <TextField {...params} size="small" />}
                                ampm={false}
                            />
                        </LocalizationProvider>
                    </Grid>

                    <Grid item container sm={2}>
                        <TextField
                            type="number"
                            label="Offset"
                            value={filter.offset}
                            onChange={(e) => this.handleChangeFilter(e, "offset")}
                            defaultValue={filter.offset}
                            style={{width: "100%"}}
                        >
                        </TextField>
                    </Grid>

                    <Grid item container sm={2}>
                        <TextField
                            type="number"
                            label="Limit"
                            value={filter.limit}
                            onChange={(e) => this.handleChangeFilter(e, "limit")}
                            defaultValue={filter.limit}
                            style={{width: "100%"}}
                        >
                        </TextField>
                    </Grid>
                </Grid>

                <Grid item container sm={12} justifyContent={"flex-end"}>
                    <Grid item sm={1}>
                        <Button
                            color="primary"
                            onClick={this.fetchData.bind(this)}
                            variant="contained"
                        >
                            Search
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    }

    renderContent() {
        const content = this.state.content;

        if (this.state.loading) {
            return <Skeleton variant="rectangular" width="100%" height={500} />
        }

        // if (content.length === 0) {
        //     return <Typography variant="h6" style={{marginTop: 16}}>No data</Typography>
        // }

        return <Table>
            <TableHead>
                <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>ID</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Start Date</TableCell>
                    <TableCell>End Date</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Winner Amount</TableCell>
                    <TableCell>Creator</TableCell>
                    <TableCell>Rewarded</TableCell>
                    <TableCell>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<AddIcon />}
                            onClick={this.onAddItem.bind(this)}
                        >
                            Add
                        </Button>
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {content.map((row: any, index: number) => (
                    <TableRow key={row.id}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell sx={{wordWrap: 'break-word', whiteSpace: 'normal'}}>{row.id}</TableCell>
                        <TableCell>{row.name}</TableCell>
                        <TableCell>{this.formatTime(row.startDate)}</TableCell>
                        <TableCell>{this.formatTime(row.endDate)}</TableCell>
                        <TableCell>{row.type}</TableCell>
                        <TableCell>{this.renderStatus(row.status)}</TableCell>
                        <TableCell>{row.winnerAmount}</TableCell>
                        <TableCell>{row.creator}</TableCell>
                        <TableCell>{row.isRewarded ?
                            <CheckCircleIcon style={{color: green[500]}} /> :
                            <CancelIcon style={{color: red[500]}} />
                        }</TableCell>
                        <TableCell>
                            <Button
                                variant="outlined"
                                color="warning"
                                startIcon={<EditIcon />}
                                onClick={this.onEditItem.bind(this, row)}
                            >
                                Edit
                            </Button>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    }

    render() {
        return <Paper className="contentPadding">
            <CardHeader title="Ruby Competition" />
            {this.renderFilter()}
            <br></br>
            {
                this.state.loading ? <Skeleton variant="rectangular" width="100%" height={500} /> : <div>
                    {this.renderContent()}

                    {this.renderDetailDialog()}
                    {this.renderCreateDialog()}
                    {this.renderConfig()}
                    {this.renderStatsDialog()}
                </div>
            }

        </Paper>
    }
}

const styles: any = theme => ({
    actions: {
        color: theme.palette.text.secondary,
        float: "right",
    },
    button: {
        margin: 8,
    },
});

export const RubyCompetition = withStyles(styles)(RubyCompetitionWrapped);